module.exports = __webpack_public_path__ + "static/media/arrow-circle-right.722f1403.svg";